import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  return (
    <Tooltip title={t('language.toggle')}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setLanguage(language === 'en' ? 'ar' : 'en')}
        sx={{
          backgroundColor: 'background.paper',
          border: '1px solid', borderColor: 'divider',
          borderRadius: '999px',
          color: 'text.secondary',
          minWidth: 'auto', px: 2, gap: 0.8,
          '&:hover': { backgroundColor: 'action.hover' },
          boxShadow: 1,
        }}
      >
        <Box component="span">{language === 'en' ? 'العربية' : 'English'}</Box>
        <LanguageIcon fontSize="small" />
      </Button>
    </Tooltip>
  );
};

export default LanguageToggle;
